/* BioNatura — étal tournant en 3D (three.js)
   Paniers en osier et cagette entièrement générés en code : aucune maquette à charger. */
import * as THREE from 'three';

const hero = document.querySelector('[data-hero]');
if (hero) init();

function init() {
  let data = [];
  try { data = JSON.parse(document.querySelector('[data-hero-data]').textContent); } catch (e) { data = []; }
  if (!data.length) return;

  const ui = {
    ecr: hero.querySelector('[data-hero-ecriteau]'),
    sous: hero.querySelector('[data-h-sous]'),
    nom: hero.querySelector('[data-h-nom]'),
    contenu: hero.querySelector('[data-h-contenu]'),
    prefix: hero.querySelector('[data-h-prefix]'),
    prix: hero.querySelector('[data-h-prix]'),
    ajouter: hero.querySelector('[data-h-ajouter]'),
    lien: hero.querySelector('[data-h-lien]'),
    points: hero.querySelector('[data-h-points]'),
    prec: hero.querySelector('[data-h-prec]'),
    suiv: hero.querySelector('[data-h-suiv]'),
    canvas: hero.querySelector('[data-hero-canvas]'),
    repli: hero.querySelector('[data-hero-repli]')
  };
  const N = data.length;
  let actuel = 0;
  let scene3d = null;

  data.forEach((d, i) => {
    const li = document.createElement('li');
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', d.nom);
    b.addEventListener('click', () => choisir(i));
    li.appendChild(b);
    ui.points.appendChild(li);
  });

  function afficher(i, anime) {
    const d = data[i];
    const maj = () => {
      ui.sous.textContent = d.sous || '';
      ui.nom.textContent = d.nom;
      ui.contenu.textContent = d.contenu || '';
      ui.prefix.textContent = d.prefix || '';
      ui.prix.textContent = d.prix;
      ui.lien.href = d.url;
      ui.lien.textContent = d.type === 'composer' ? 'Voir les produits' : 'Voir le détail';
      if (d.variante) {
        ui.ajouter.dataset.ajouter = d.variante;
        ui.ajouter.dataset.nom = d.nom;
        ui.ajouter.textContent = 'Ajouter au panier';
      } else {
        delete ui.ajouter.dataset.ajouter;
        ui.ajouter.textContent = 'Composer mon panier';
      }
    };
    if (anime) {
      ui.ecr.classList.remove('is-tourne'); void ui.ecr.offsetWidth; ui.ecr.classList.add('is-tourne');
      setTimeout(maj, 200);
    } else maj();
    [...ui.points.querySelectorAll('button')].forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false'));
  }
  function choisir(i) {
    i = ((i % N) + N) % N;
    if (i === actuel) return;
    actuel = i;
    afficher(i, true);
    if (scene3d) scene3d.viser(i);
  }
  ui.ajouter.addEventListener('click', () => {
    if (!data[actuel].variante) {
      const c = document.getElementById('composer');
      if (c) c.scrollIntoView({ behavior: 'smooth' });
    }
  });
  ui.prec.addEventListener('click', () => choisir(actuel - 1));
  ui.suiv.addEventListener('click', () => choisir(actuel + 1));
  hero.addEventListener('keydown', (e) => {
    if (e.target.closest('input,textarea')) return;
    if (e.key === 'ArrowLeft') choisir(actuel - 1);
    if (e.key === 'ArrowRight') choisir(actuel + 1);
  });
  afficher(0, false);

  const lancer = () => {
    try {
      scene3d = creerScene(ui.canvas, data, (i) => { if (i !== actuel) { actuel = i; afficher(i, true); } });
      scene3d.viser(actuel);
    } catch (err) {
      console.warn('BioNatura 3D indisponible', err);
      ui.canvas.hidden = true;
      ui.repli.hidden = false;
      ui.repli.style.setProperty('--repli', getComputedStyle(hero).getPropertyValue('--fond'));
    }
  };
  // la police de la pancarte doit être chargée avant de peindre sa texture
  const police = document.fonts && document.fonts.load ? document.fonts.load('86px Caprasimo') : Promise.resolve();
  Promise.race([police, new Promise((r) => setTimeout(r, 1500))]).catch(() => {}).then(lancer);
}

/* =========================================================
   Outils : hasard reproductible, bruit, textures peintes
   ========================================================= */
function rng(seed) {
  let a = seed >>> 0;
  return () => { a |= 0; a = (a + 0x6D2B79F5) | 0; let t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
}
function h3(x, y, z) {
  let h = Math.imul(x | 0, 374761393) ^ Math.imul(y | 0, 668265263) ^ Math.imul(z | 0, 1440662683);
  h = Math.imul(h ^ (h >>> 13), 1274126177); h ^= h >>> 16;
  return (h >>> 0) / 4294967296;
}
function vnoise(x, y, z) {
  const xi = Math.floor(x), yi = Math.floor(y), zi = Math.floor(z);
  const xf = x - xi, yf = y - yi, zf = z - zi;
  const s = (t) => t * t * (3 - 2 * t);
  const u = s(xf), v = s(yf), w = s(zf);
  const L = (a, b, t) => a + (b - a) * t;
  return L(
    L(L(h3(xi, yi, zi), h3(xi + 1, yi, zi), u), L(h3(xi, yi + 1, zi), h3(xi + 1, yi + 1, zi), u), v),
    L(L(h3(xi, yi, zi + 1), h3(xi + 1, yi, zi + 1), u), L(h3(xi, yi + 1, zi + 1), h3(xi + 1, yi + 1, zi + 1), u), v), w);
}
function fbm(x, y, z, o = 4) {
  let s = 0, a = 0.5, f = 1;
  for (let i = 0; i < o; i++) { s += a * vnoise(x * f, y * f, z * f); f *= 2.03; a *= 0.5; }
  return s;
}

function canvasTex(w, h, peindre, repeat) {
  const c = document.createElement('canvas'); c.width = w; c.height = h;
  const g = c.getContext('2d');
  peindre(g, w, h);
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  if (repeat) t.repeat.set(repeat[0], repeat[1]);
  t.anisotropy = 4;
  return t;
}

// Osier tressé : brins horizontaux qui passent dessus/dessous des montants
function texOsier(base = [184, 134, 80]) {
  return canvasTex(512, 512, (g, W, H) => {
    g.fillStyle = 'rgb(58,38,20)'; g.fillRect(0, 0, W, H);
    const rows = 16, cols = 8, rh = H / rows, cw = W / cols;
    const r = rng(7);
    for (let y = 0; y < rows; y++) {
      for (let x = 0; x < cols; x++) {
        const dessus = (x + y) % 2 === 0;
        const k = 0.82 + r() * 0.3;
        const c0 = base.map((v) => Math.min(255, v * k * (dessus ? 1.08 : 0.72)));
        const x0 = x * cw - (dessus ? 6 : -10), w = cw + (dessus ? 12 : -20);
        const gr = g.createLinearGradient(0, y * rh, 0, y * rh + rh);
        gr.addColorStop(0, `rgb(${c0.map((v) => v * 0.55)})`);
        gr.addColorStop(0.35, `rgb(${c0.map((v) => Math.min(255, v * 1.12))})`);
        gr.addColorStop(0.7, `rgb(${c0})`);
        gr.addColorStop(1, `rgb(${c0.map((v) => v * 0.45)})`);
        g.fillStyle = gr;
        g.beginPath();
        g.roundRect(x0, y * rh + 2, w, rh - 4, rh / 2);
        g.fill();
        // fibres
        g.strokeStyle = 'rgba(70,45,20,.22)'; g.lineWidth = 1;
        for (let f = 0; f < 3; f++) { const yy = y * rh + 6 + r() * (rh - 12); g.beginPath(); g.moveTo(x0 + 6, yy); g.lineTo(x0 + w - 6, yy + r() * 2 - 1); g.stroke(); }
      }
    }
  }, [6, 2.2]);
}
function texCorde() {
  return canvasTex(256, 64, (g, W, H) => {
    g.fillStyle = '#7b5530'; g.fillRect(0, 0, W, H);
    for (let i = -4; i < 24; i++) {
      const gr = g.createLinearGradient(i * 16, 0, i * 16 + 22, H);
      gr.addColorStop(0, '#5a3b1d'); gr.addColorStop(0.5, '#c79a63'); gr.addColorStop(1, '#5a3b1d');
      g.fillStyle = gr;
      g.beginPath(); g.moveTo(i * 16, 0); g.lineTo(i * 16 + 12, 0); g.lineTo(i * 16 + 34, H); g.lineTo(i * 16 + 22, H); g.fill();
    }
  }, [18, 1]);
}
function texBois(teinte = [176, 128, 80], rep = [1, 1]) {
  return canvasTex(512, 256, (g, W, H) => {
    const img = g.createImageData(W, H);
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      const n = fbm(x / 140, y / 9, 3.1, 4);
      const ve = 0.5 + 0.5 * Math.sin((y / 6) + n * 9);
      const k = 0.84 + 0.16 * ve + (fbm(x / 7, y / 7, 9, 2) - 0.5) * 0.1;
      const i = (y * W + x) * 4;
      img.data[i] = teinte[0] * k; img.data[i + 1] = teinte[1] * k; img.data[i + 2] = teinte[2] * k; img.data[i + 3] = 255;
    }
    g.putImageData(img, 0, 0);
  }, rep);
}
function texPeauAgrume() {
  return canvasTex(256, 256, (g, W, H) => {
    g.fillStyle = '#808080'; g.fillRect(0, 0, W, H);
    const r = rng(3);
    for (let i = 0; i < 1400; i++) { g.fillStyle = `rgba(40,40,40,${0.25 + r() * 0.35})`; g.beginPath(); g.arc(r() * W, r() * H, 1 + r() * 1.6, 0, 7); g.fill(); }
  }, [3, 2]);
}

/* =========================================================
   Géométrie
   ========================================================= */
function deformer(geo, fn) {
  const p = geo.attributes.position, n = geo.attributes.normal, v = new THREE.Vector3(), nn = new THREE.Vector3();
  for (let i = 0; i < p.count; i++) {
    v.fromBufferAttribute(p, i); nn.fromBufferAttribute(n, i);
    fn(v, nn, i);
    p.setXYZ(i, v.x, v.y, v.z);
  }
  geo.computeVertexNormals();
  return geo;
}
function colorer(geo, fn) {
  const p = geo.attributes.position, cols = new Float32Array(p.count * 3), v = new THREE.Vector3(), c = new THREE.Color();
  for (let i = 0; i < p.count; i++) { v.fromBufferAttribute(p, i); fn(v, c); cols.set([c.r, c.g, c.b], i * 3); }
  geo.setAttribute('color', new THREE.BufferAttribute(cols, 3));
  return geo;
}
const M = (opts) => new THREE.MeshPhysicalMaterial(Object.assign({ roughness: 0.6, metalness: 0 }, opts));
function ombre(o) { o.traverse((m) => { if (m.isMesh) { m.castShadow = true; m.receiveShadow = true; } }); return o; }
function profil(n, fn) { const pts = []; for (let i = 0; i <= n; i++) { const [r, y] = fn(i / n); pts.push(new THREE.Vector2(Math.max(0.0001, r), y)); } return pts; }

/* ---------- les fruits et légumes ---------- */
const P = {};
P.courge = (r, couleur = 0xd8641c, seed = 1) => {
  const g = new THREE.Group();
  const base = new THREE.Color(couleur);
  const geo = deformer(new THREE.SphereGeometry(r, 64, 40), (v) => {
    const th = Math.atan2(v.z, v.x);
    const sillon = Math.pow(1 - Math.abs(Math.sin(th * 5)), 5);
    const k = 1 - 0.07 * sillon + (fbm(v.x * 3 + seed, v.y * 3, v.z * 3) - 0.5) * 0.06;
    v.x *= k; v.z *= k; v.y *= 0.74;
    const rxz = Math.hypot(v.x, v.z) / r;
    v.y -= Math.sign(v.y) * 0.12 * r * Math.exp(-rxz * rxz * 9);
  });
  colorer(geo, (v, c) => {
    const th = Math.atan2(v.z, v.x);
    const sillon = Math.pow(1 - Math.abs(Math.sin(th * 5)), 4);
    const n = fbm(v.x * 6, v.y * 6, v.z * 6 + seed);
    c.copy(base).multiplyScalar(0.8 + 0.25 * n - 0.25 * sillon);
  });
  g.add(new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.55, clearcoat: 0.25, clearcoatRoughness: 0.6 })));
  const tige = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.07, r * 0.11, r * 0.32, 10), M({ color: 0x6b6b34, roughness: 0.9 }));
  tige.position.y = r * 0.7; tige.rotation.z = 0.25; g.add(tige);
  return g;
};
P.butternut = (s = 1) => {
  const ss = (a, b, x) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
  const geo = new THREE.LatheGeometry(profil(48, (t) => {
    const r = (0.25 * Math.exp(-Math.pow((t - 0.22) / 0.21, 2)) + 0.135 * ss(0.22, 0.42, t)) * Math.pow(Math.sin(Math.PI * t), 0.35);
    return [r, t * 0.82];
  }).map((v) => v.multiplyScalar(s)), 40);
  colorer(geo, (v, c) => c.setRGB(0.88, 0.66, 0.42).multiplyScalar(0.88 + 0.16 * fbm(v.x * 8, v.y * 8, v.z * 8)));
  const m = new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.45, clearcoat: 0.3 }));
  const g = new THREE.Group(); m.position.y = -0.4 * s; g.add(m);
  const tige = new THREE.Mesh(new THREE.CylinderGeometry(0.025 * s, 0.04 * s, 0.08 * s, 8), M({ color: 0x7c6a3a }));
  tige.position.y = 0.43 * s; g.add(tige);
  return g;
};
P.pomme = (r = 0.15, teinte = 'rouge', seed = 1) => {
  const geo = new THREE.LatheGeometry(profil(32, (t) => {
    const a = -Math.PI / 2 + t * Math.PI;
    let rr = Math.cos(a) * (1 + 0.1 * Math.sin(a)), y = Math.sin(a) * 0.9;
    if (t > 0.86) y -= (t - 0.86) * 1.3; if (t < 0.1) y += (0.1 - t) * 0.8;
    return [rr * r, y * r];
  }), 40);
  const base = teinte === 'rouge' ? new THREE.Color(0xb3241f) : teinte === 'verte' ? new THREE.Color(0x9cbf3a) : new THREE.Color(0xc9b23a);
  const jaune = new THREE.Color(0xe6c34a);
  colorer(geo, (v, c) => {
    const n = fbm(v.x * 9 + seed, v.y * 30, v.z * 9);
    c.copy(base).lerp(jaune, Math.max(0, n - 0.45) * (teinte === 'rouge' ? 1.3 : 0.6));
  });
  const g = new THREE.Group();
  g.add(new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.32, clearcoat: 0.6, clearcoatRoughness: 0.25 })));
  const q = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.04, r * 0.05, r * 0.35, 6), M({ color: 0x4d3a1e }));
  q.position.y = r * 0.82; q.rotation.z = 0.3; g.add(q);
  return g;
};
P.poire = (s = 1) => {
  const geo = new THREE.LatheGeometry(profil(40, (t) => {
    const y = t * 0.36;
    const r = 0.15 * Math.sin(Math.pow(t, 0.85) * Math.PI) * (1 - 0.45 * t) + 0.02 * Math.sin(t * Math.PI);
    return [r, y];
  }).map((v) => v.multiplyScalar(s)), 36);
  colorer(geo, (v, c) => c.setRGB(0.66, 0.7, 0.24).lerp(new THREE.Color(0.78, 0.55, 0.22), fbm(v.x * 12, v.y * 12, v.z * 12) * 0.6));
  const g = new THREE.Group();
  const m = new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.5, clearcoat: 0.2 })); m.position.y = -0.12 * s; g.add(m);
  const q = new THREE.Mesh(new THREE.CylinderGeometry(0.006 * s, 0.009 * s, 0.07 * s, 6), M({ color: 0x4d3a1e })); q.position.y = 0.26 * s; q.rotation.z = -0.4; g.add(q);
  return g;
};
P.carotte = (L = 0.6, couleur = 0xe8741c, seed = 1) => {
  const geo = new THREE.LatheGeometry(profil(30, (t) => [0.075 * Math.pow(t, 0.7) * (1 + 0.04 * Math.sin(t * 60)), t * L]), 20);
  colorer(geo, (v, c) => {
    const b = new THREE.Color(couleur);
    c.copy(b).multiplyScalar(0.8 + 0.25 * Math.abs(Math.sin(v.y * 70 + seed)) * fbm(v.x * 20, v.y * 20, v.z * 20));
  });
  const g = new THREE.Group();
  const m = new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.55 })); m.position.y = -L / 2; g.add(m);
  const fane = M({ color: 0x3f7a2a, roughness: 0.7, side: THREE.DoubleSide });
  for (let i = 0; i < 6; i++) {
    const f = new THREE.Mesh(new THREE.ConeGeometry(0.03, 0.42, 5), fane);
    f.position.y = L / 2 + 0.17; f.rotation.z = (i - 2.5) * 0.18; f.rotation.x = (i % 2 ? 0.2 : -0.2);
    g.add(f);
  }
  return g;
};
P.poireau = (L = 1.25) => {
  const g = new THREE.Group();
  const fut = new THREE.CylinderGeometry(0.075, 0.085, L * 0.62, 18, 12);
  colorer(fut, (v, c) => { const t = (v.y + L * 0.31) / (L * 0.62); c.setRGB(0.95, 0.96, 0.9).lerp(new THREE.Color(0.55, 0.72, 0.38), Math.pow(Math.max(0, t - 0.45) / 0.55, 1.3)); });
  const m = new THREE.Mesh(fut, M({ vertexColors: true, roughness: 0.45, clearcoat: 0.2 }));
  g.add(m);
  const feuille = M({ color: 0x2f5f2b, roughness: 0.6, side: THREE.DoubleSide });
  for (let i = 0; i < 5; i++) {
    const geo = deformer(new THREE.PlaneGeometry(0.12, L * 0.55, 1, 10), (v) => { const t = (v.y + L * 0.275) / (L * 0.55); v.z += t * t * 0.18 * (i % 2 ? 1 : -1); v.x *= 1 - t * 0.5; });
    const f = new THREE.Mesh(geo, feuille);
    f.position.y = L * 0.31 + L * 0.25; f.rotation.y = i * 1.25; f.rotation.z = (i - 2) * 0.14;
    g.add(f);
  }
  const rac = new THREE.Mesh(new THREE.SphereGeometry(0.06, 8, 6), M({ color: 0xd8cfb4, roughness: 1 }));
  rac.scale.set(1.2, 0.5, 1.2); rac.position.y = -L * 0.31; g.add(rac);
  return g;
};
P.chou = (r = 0.3, couleur = 0x7fa647, frise = 0, seed = 1) => {
  const g = new THREE.Group();
  const base = new THREE.Color(couleur);
  const geo = deformer(new THREE.SphereGeometry(r, 64, 48), (v, n) => {
    const d = frise ? (fbm(v.x * 14 + seed, v.y * 14, v.z * 14, 3) - 0.5) * r * 0.5 : (fbm(v.x * 4 + seed, v.y * 4, v.z * 4) - 0.5) * r * 0.25;
    v.addScaledVector(n, d); v.y *= 0.9;
  });
  colorer(geo, (v, c) => {
    const nervure = Math.pow(Math.abs(Math.sin(Math.atan2(v.z, v.x) * 7 + v.y * 9)), 18);
    c.copy(base).multiplyScalar(0.8 + 0.3 * fbm(v.x * 10, v.y * 10, v.z * 10 + seed)).lerp(new THREE.Color(0xe6efc8), nervure * 0.5);
  });
  g.add(new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.55, clearcoat: frise ? 0 : 0.35 })));
  if (!frise) {
    const fmat = M({ color: base.clone().multiplyScalar(0.85), roughness: 0.55, side: THREE.DoubleSide });
    for (let i = 0; i < 5; i++) {
      const f = new THREE.Mesh(new THREE.SphereGeometry(r * 1.08, 24, 12, 0, Math.PI * 0.9, Math.PI * 0.35, Math.PI * 0.45), fmat);
      f.rotation.y = i * (Math.PI * 2 / 5); g.add(f);
    }
  }
  return g;
};
P.choufleur = (r = 0.28) => {
  const g = new THREE.Group();
  const tete = deformer(new THREE.SphereGeometry(r, 72, 48, 0, Math.PI * 2, 0, Math.PI * 0.55), (v, n) => {
    v.addScaledVector(n, (fbm(v.x * 16, v.y * 16, v.z * 16, 3) - 0.3) * r * 0.22);
  });
  colorer(tete, (v, c) => c.setRGB(0.95, 0.91, 0.79).multiplyScalar(0.82 + 0.22 * fbm(v.x * 30, v.y * 30, v.z * 30)));
  const m = new THREE.Mesh(tete, M({ vertexColors: true, roughness: 0.85 }));
  m.position.y = -r * 0.25; g.add(m);
  const fmat = M({ color: 0x5e8f3a, roughness: 0.6, side: THREE.DoubleSide });
  for (let i = 0; i < 7; i++) {
    const f = new THREE.Mesh(new THREE.SphereGeometry(r * 1.15, 20, 10, 0, 0.9, Math.PI * 0.45, Math.PI * 0.35), fmat);
    f.rotation.y = i * (Math.PI * 2 / 7); f.position.y = -r * 0.15; g.add(f);
  }
  return g;
};
P.patate = (r = 0.14, seed = 1, couleur = 0xb58a58) => {
  const base = new THREE.Color(couleur);
  const geo = deformer(new THREE.SphereGeometry(r, 32, 24), (v, n) => { v.addScaledVector(n, (fbm(v.x * 5 + seed, v.y * 5, v.z * 5) - 0.5) * r * 0.5); v.x *= 1.35; v.y *= 0.85; });
  colorer(geo, (v, c) => { const n = fbm(v.x * 25 + seed, v.y * 25, v.z * 25); c.copy(base).multiplyScalar(n > 0.72 ? 0.55 : 0.85 + 0.2 * n); });
  return new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.95 }));
};
P.oignon = (r = 0.16, rouge = false) => {
  const geo = new THREE.LatheGeometry(profil(30, (t) => [r * Math.pow(Math.sin(t * Math.PI), 0.9) * (1 - 0.35 * t * t), (t - 0.4) * r * 2.1]), 36);
  const base = new THREE.Color(rouge ? 0x7a2846 : 0xc98b3c);
  colorer(geo, (v, c) => c.copy(base).multiplyScalar(0.78 + 0.3 * Math.abs(Math.sin(Math.atan2(v.z, v.x) * 9)) * 0.6 + 0.12 * fbm(v.x * 20, v.y * 20, v.z * 20)));
  const g = new THREE.Group();
  g.add(new THREE.Mesh(geo, M({ vertexColors: true, roughness: 0.4, clearcoat: 0.5, clearcoatRoughness: 0.4 })));
  const pointe = new THREE.Mesh(new THREE.ConeGeometry(r * 0.12, r * 0.6, 8), M({ color: rouge ? 0x5c2236 : 0x8e5d27, roughness: 0.8 }));
  pointe.position.y = r * 1.4; g.add(pointe);
  return g;
};
let peauAgrume = null;
P.clementine = (r = 0.12) => {
  peauAgrume = peauAgrume || texPeauAgrume();
  const g = new THREE.Group();
  const s = new THREE.Mesh(new THREE.SphereGeometry(r, 36, 28), M({ color: 0xf08a1e, roughness: 0.45, bumpMap: peauAgrume, bumpScale: 0.6, clearcoat: 0.4 }));
  s.scale.y = 0.86; g.add(s);
  const feuille = new THREE.Mesh(new THREE.SphereGeometry(r * 0.9, 12, 8, 0, Math.PI, 0, Math.PI), M({ color: 0x2f6a2a, roughness: 0.4, side: THREE.DoubleSide }));
  feuille.scale.set(0.45, 0.06, 1); feuille.position.set(r * 0.25, r * 0.86, r * 0.4); feuille.rotation.set(0.4, 0.6, 0.2); g.add(feuille);
  return g;
};
P.betterave = (r = 0.15) => {
  const g = new THREE.Group();
  const b = new THREE.Mesh(deformer(new THREE.SphereGeometry(r, 32, 24), (v, n) => v.addScaledVector(n, (fbm(v.x * 6, v.y * 6, v.z * 6) - 0.5) * r * 0.2)), M({ color: 0x6b1b2b, roughness: 0.55 }));
  g.add(b);
  const rac = new THREE.Mesh(new THREE.ConeGeometry(r * 0.25, r * 1.4, 8), M({ color: 0x5c1a26 })); rac.rotation.x = Math.PI; rac.position.y = -r * 1.2; g.add(rac);
  const tm = M({ color: 0x9a2a3a });
  for (let i = 0; i < 3; i++) { const t = new THREE.Mesh(new THREE.CylinderGeometry(0.008, 0.012, r * 2.2, 5), tm); t.position.y = r * 1.6; t.rotation.z = (i - 1) * 0.3; g.add(t); }
  return g;
};
P.champignon = (r = 0.08) => {
  const g = new THREE.Group();
  const chap = new THREE.Mesh(new THREE.SphereGeometry(r, 24, 12, 0, Math.PI * 2, 0, Math.PI / 2), M({ color: 0xece4d4, roughness: 0.7 }));
  chap.scale.y = 0.75; chap.position.y = r * 0.5; g.add(chap);
  const dessous = new THREE.Mesh(new THREE.CircleGeometry(r * 0.98, 24), M({ color: 0x9c8466, roughness: 1, side: THREE.DoubleSide }));
  dessous.rotation.x = Math.PI / 2; dessous.position.y = r * 0.5; g.add(dessous);
  const pied = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.32, r * 0.38, r * 0.7, 12), M({ color: 0xf2ece0, roughness: 0.8 }));
  pied.position.y = r * 0.15; g.add(pied);
  return g;
};
P.kiwi = (r = 0.1) => {
  const m = new THREE.Mesh(deformer(new THREE.SphereGeometry(r, 24, 18), (v) => { v.x *= 1.3; }), M({ color: 0x83643a, roughness: 1, sheen: 1, sheenColor: new THREE.Color(0xb08e5c), sheenRoughness: 0.8 }));
  return m;
};
P.mache = (r = 0.18) => {
  const g = new THREE.Group();
  const mat = M({ color: 0x4c8a34, roughness: 0.4, clearcoat: 0.3, side: THREE.DoubleSide });
  const R = rng(11);
  for (let i = 0; i < 26; i++) {
    const f = new THREE.Mesh(new THREE.SphereGeometry(r * 0.32, 10, 6, 0, Math.PI), mat);
    f.scale.set(0.5, 0.12, 1);
    const a = R() * Math.PI * 2, d = R() * r * 0.9;
    f.position.set(Math.cos(a) * d, R() * r * 0.5, Math.sin(a) * d);
    f.rotation.set(R() * 1.2 - 0.6, a, R() * 0.6);
    g.add(f);
  }
  return g;
};

/* ---------- contenants ---------- */
function panierOsier({ rBas = 0.9, rHaut = 1.3, h = 0.8, anse = true, oreilles = false, ovale = 1, teinte }) {
  const g = new THREE.Group();
  const osier = texOsier(teinte);
  const mat = M({ map: osier, bumpMap: osier, bumpScale: 2.2, roughness: 0.85, side: THREE.DoubleSide });
  const pts = profil(36, (t) => [t < 0.06 ? rBas * (t / 0.06) : rBas + (rHaut - rBas) * Math.pow((t - 0.06) / 0.94, 0.75) + 0.06 * Math.sin(((t - 0.06) / 0.94) * Math.PI), t < 0.06 ? 0 : ((t - 0.06) / 0.94) * h]);
  const corps = new THREE.Mesh(new THREE.LatheGeometry(pts, 72), mat);
  corps.scale.x = ovale;
  g.add(corps);
  const corde = texCorde();
  const bord = new THREE.Mesh(new THREE.TorusGeometry(rHaut + 0.035, 0.065, 14, 120), M({ map: corde, bumpMap: corde, bumpScale: 1.5, roughness: 0.8 }));
  bord.rotation.x = Math.PI / 2; bord.position.y = h; bord.scale.x = ovale; g.add(bord);
  if (anse) {
    const cA = texCorde(); cA.repeat.set(30, 1);
    const a = new THREE.Mesh(new THREE.TorusGeometry(rHaut * ovale * 0.98, 0.06, 12, 90, Math.PI), M({ map: cA, bumpMap: cA, bumpScale: 1.5, roughness: 0.8 }));
    a.position.y = h; a.scale.y = 0.95; g.add(a);
  }
  if (oreilles) {
    [-1, 1].forEach((s) => {
      const o = new THREE.Mesh(new THREE.TorusGeometry(0.2, 0.045, 10, 30, Math.PI), M({ map: corde, roughness: 0.8 }));
      o.rotation.y = Math.PI / 2; o.position.set(s * (rHaut * ovale + 0.02), h - 0.04, 0); g.add(o);
    });
  }
  return ombre(g);
}
function cagette() {
  const g = new THREE.Group();
  const bois = texBois([196, 150, 98], [1, 1]);
  const mat = M({ map: bois, roughness: 0.75 });
  const W = 2.3, D = 1.55, H = 0.9;
  const planche = (w, h, d, x, y, z) => { const m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), mat); m.position.set(x, y, z); g.add(m); return m; };
  planche(W, 0.06, D, 0, 0.03, 0); // fond
  [0.18, 0.5, 0.8].forEach((y) => { planche(W, 0.16, 0.04, 0, y, D / 2); planche(W, 0.16, 0.04, 0, y, -D / 2); });
  [-1, 1].forEach((s) => { const t = planche(0.06, H, D, s * (W / 2 - 0.03), H / 2, 0); t.material = M({ map: texBois([170, 124, 76]), roughness: 0.8 }); });
  [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(([a, b]) => planche(0.09, H + 0.04, 0.09, a * (W / 2 - 0.05), H / 2, b * (D / 2 - 0.05)));
  return ombre(g);
}
function pancarte(texte) {
  const tex = canvasTex(512, 256, (g, W, H) => {
    g.fillStyle = '#FBFCF8'; g.beginPath(); g.roundRect(0, 0, W, H, 26); g.fill();
    g.strokeStyle = '#1E3B2C'; g.lineWidth = 10; g.beginPath(); g.roundRect(22, 22, W - 44, H - 44, 14); g.stroke();
    g.fillStyle = '#1E3B2C'; g.font = '86px Caprasimo, Georgia, serif'; g.textAlign = 'center'; g.textBaseline = 'middle';
    g.fillText(texte, W / 2, H / 2 + 6);
    g.fillStyle = '#9aa39a'; [[40, 40], [W - 40, 40], [40, H - 40], [W - 40, H - 40]].forEach(([x, y]) => { g.beginPath(); g.arc(x, y, 9, 0, 7); g.fill(); });
  });
  tex.wrapS = tex.wrapT = THREE.ClampToEdgeWrapping;
  const grp = new THREE.Group();
  const p = new THREE.Mesh(new THREE.BoxGeometry(1.1, 0.55, 0.03), [M({ color: 0xe9ece4 }), M({ color: 0xe9ece4 }), M({ color: 0xe9ece4 }), M({ color: 0xe9ece4 }), M({ map: tex, roughness: 0.35, clearcoat: 0.6 }), M({ color: 0xdfe3da })]);
  p.position.y = 0.95; grp.add(p);
  const pique = new THREE.Mesh(new THREE.CylinderGeometry(0.025, 0.025, 1.0, 8), M({ map: texBois([150, 105, 60]) }));
  pique.position.y = 0.35; grp.add(pique);
  return ombre(grp);
}

/* ---------- remplissage en tas ---------- */
function entasser(groupe, objets, { rayon, base, bombe, ovale = 1, seed = 1, echelle = 1.22 }) {
  const R = rng(seed);
  objets.forEach((o) => o.obj.scale.multiplyScalar(echelle));
  const tas = objets.filter((o) => !o.debout), debout = objets.filter((o) => o.debout);
  const n = tas.length;
  tas.forEach((o, i) => {
    const rr = rayon * (o.couche ? 0.42 : 0.72) * Math.sqrt((i + 0.35) / n);
    const a = i * 2.39996 + R() * 0.4;
    const x = Math.cos(a) * rr * ovale, z = Math.sin(a) * rr;
    const y = base + bombe * (1 - Math.pow(rr / rayon, 2)) + (o.haut || 0.12) * 0.75 * echelle + R() * 0.04;
    o.obj.position.set(x, y, z);
    if (!o.fixe) o.obj.rotation.set(R() * 0.8 - 0.4, R() * Math.PI * 2, R() * 0.8 - 0.4);
    if (o.couche) { o.obj.rotation.z = Math.PI / 2 + R() * 0.3; o.obj.rotation.y = a; }
    groupe.add(ombre(o.obj));
  });
  debout.forEach((o, i) => {
    const a = (o.angle !== undefined ? o.angle : -0.6 + i * 0.5);
    const rr = rayon * 0.55;
    o.obj.position.set(Math.cos(a) * rr * ovale, base + bombe * 0.5 + (o.haut || 0.5) * 0.5, Math.sin(a) * rr * 0.6 - rayon * 0.15);
    o.obj.rotation.set(-0.35 + R() * 0.15, 0, -Math.cos(a) * 0.45 + R() * 0.1);
    groupe.add(ombre(o.obj));
  });
}

function construirePanier(forme) {
  const g = new THREE.Group();
  if (forme === 1) {
    g.add(panierOsier({ rBas: 0.82, rHaut: 1.18, h: 0.72, anse: true }));
    entasser(g, [
      { obj: P.courge(0.34, 0xd8641c, 2), haut: 0.5, fixe: true },
      { obj: P.patate(0.13, 1), haut: 0.2 }, { obj: P.patate(0.12, 2), haut: 0.2 }, { obj: P.patate(0.13, 3), haut: 0.2 },
      { obj: P.pomme(0.15, 'rouge', 1), haut: 0.3 }, { obj: P.pomme(0.14, 'rouge', 2), haut: 0.3 },
      { obj: P.oignon(0.14), haut: 0.3 }, { obj: P.oignon(0.13), haut: 0.3 },
      { obj: P.mache(0.22), haut: 0.2 }, { obj: P.patate(0.12, 9), haut: 0.2 }, { obj: P.pomme(0.14, 'jaune', 12), haut: 0.3 },
      { obj: P.oignon(0.13, true), haut: 0.3 }, { obj: P.patate(0.125, 10), haut: 0.2 },
      { obj: P.carotte(0.6, 0xe8741c, 1), couche: true, haut: 0.15 }, { obj: P.carotte(0.55, 0xe8741c, 2), couche: true, haut: 0.15 },
      { obj: P.poireau(1.3), debout: true, angle: -0.3, haut: 1.2 }, { obj: P.poireau(1.2), debout: true, angle: 0.25, haut: 1.1 }
    ], { rayon: 1.08, base: 0.3, bombe: 0.32, seed: 3 });
  } else if (forme === 2) {
    const ov = 1.32;
    g.add(panierOsier({ rBas: 0.85, rHaut: 1.12, h: 0.56, anse: false, oreilles: true, ovale: ov, teinte: [168, 120, 70] }));
    entasser(g, [
      { obj: P.butternut(1.05), couche: true, haut: 0.4 },
      { obj: P.choufleur(0.3), haut: 0.4, fixe: true },
      { obj: P.betterave(0.14), haut: 0.25 }, { obj: P.betterave(0.13), haut: 0.25 },
      { obj: P.pomme(0.14, 'verte', 3), haut: 0.3 }, { obj: P.pomme(0.14, 'rouge', 4), haut: 0.3 },
      { obj: P.poire(1.1), haut: 0.35, fixe: true }, { obj: P.poire(1), haut: 0.35, fixe: true },
      { obj: P.patate(0.12, 4), haut: 0.2 }, { obj: P.patate(0.13, 5), haut: 0.2 }, { obj: P.patate(0.12, 11), haut: 0.2 },
      { obj: P.pomme(0.14, 'rouge', 13), haut: 0.3 }, { obj: P.betterave(0.13), haut: 0.25 }, { obj: P.mache(0.2), haut: 0.2 },
      { obj: P.carotte(0.6, 0xe8741c, 3), couche: true, haut: 0.15 }, { obj: P.carotte(0.58, 0xe06a18, 4), couche: true, haut: 0.15 }, { obj: P.carotte(0.55, 0xe8741c, 5), couche: true, haut: 0.15 },
      { obj: P.poireau(1.25), debout: true, angle: 0.1, haut: 1.1 }
    ], { rayon: 1.0, base: 0.22, bombe: 0.28, ovale: ov, seed: 5 });
  } else if (forme === 3) {
    g.add(panierOsier({ rBas: 0.98, rHaut: 1.36, h: 0.95, anse: true, teinte: [192, 146, 92] }));
    entasser(g, [
      { obj: P.courge(0.4, 0xc95a18, 4), haut: 0.6, fixe: true },
      { obj: P.chou(0.32, 0x2d5a28, 1, 2), haut: 0.5 },
      { obj: P.chou(0.3, 0x86ad4c, 0, 3), haut: 0.5 },
      { obj: P.clementine(0.12), haut: 0.22 }, { obj: P.clementine(0.115), haut: 0.22 }, { obj: P.clementine(0.12), haut: 0.22 },
      { obj: P.champignon(0.09), haut: 0.15 }, { obj: P.champignon(0.08), haut: 0.15 }, { obj: P.champignon(0.085), haut: 0.15 },
      { obj: P.kiwi(0.1), haut: 0.18 }, { obj: P.kiwi(0.095), haut: 0.18 },
      { obj: P.pomme(0.15, 'rouge', 5), haut: 0.3 }, { obj: P.pomme(0.145, 'jaune', 6), haut: 0.3 },
      { obj: P.oignon(0.15, true), haut: 0.3 }, { obj: P.oignon(0.14), haut: 0.3 },
      { obj: P.carotte(0.62, 0xe8741c, 6), couche: true, haut: 0.15 }, { obj: P.carotte(0.6, 0xe9e0c0, 7), couche: true, haut: 0.15 }, { obj: P.carotte(0.58, 0xe9e0c0, 8), couche: true, haut: 0.15 },
      { obj: P.poireau(1.4), debout: true, angle: -0.5, haut: 1.3 }, { obj: P.poireau(1.3), debout: true, angle: 0, haut: 1.2 }, { obj: P.poireau(1.35), debout: true, angle: 0.45, haut: 1.25 }
    ], { rayon: 1.25, base: 0.4, bombe: 0.36, seed: 9 });
  } else {
    const c = cagette(); g.add(c);
    const contenu = new THREE.Group();
    entasser(contenu, [
      { obj: P.clementine(0.13), haut: 0.22 }, { obj: P.clementine(0.12), haut: 0.22 }, { obj: P.clementine(0.125), haut: 0.22 },
      { obj: P.pomme(0.15, 'rouge', 8), haut: 0.3 }, { obj: P.pomme(0.15, 'verte', 9), haut: 0.3 },
      { obj: P.chou(0.3, 0x86ad4c, 0, 5), haut: 0.5 },
      { obj: P.patate(0.13, 7), haut: 0.2 }, { obj: P.patate(0.12, 8), haut: 0.2 }
    ], { rayon: 0.62, base: 0.06, bombe: 0.12, seed: 13 });
    contenu.position.x = -0.42; g.add(contenu);
    const p = pancarte('À vous !'); p.position.set(0.55, 0.05, 0.05); p.rotation.y = -0.15; p.rotation.z = 0.05; g.add(p);
  }
  return g;
}

/* =========================================================
   Scène
   ========================================================= */
function creerScene(canvas, data, surChoix) {
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  if (!renderer.getContext()) throw new Error('WebGL');
  const petit = window.innerWidth < 760;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, petit ? 1.5 : 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);
  const cible = new THREE.Vector3(0, 0.85, 1.6);

  scene.add(new THREE.HemisphereLight(0xfff3dc, 0x3c4a2a, 1.25));
  const soleil = new THREE.DirectionalLight(0xffdfb0, 2.6);
  soleil.position.set(4.5, 8, 6);
  soleil.castShadow = true;
  soleil.shadow.mapSize.set(petit ? 1024 : 2048, petit ? 1024 : 2048);
  Object.assign(soleil.shadow.camera, { left: -6, right: 6, top: 6, bottom: -6, near: 1, far: 30 });
  soleil.shadow.bias = -0.0004; soleil.shadow.normalBias = 0.02;
  scene.add(soleil);
  const contre = new THREE.DirectionalLight(0xcfe8ff, 0.9); contre.position.set(-6, 4, -5); scene.add(contre);

  // l'étal tournant
  const etal = new THREE.Group();
  scene.add(etal);
  const plateau = new THREE.Mesh(new THREE.CylinderGeometry(5, 5.1, 0.28, 96, 1), [
    M({ map: texBois([120, 84, 50], [6, 1]), roughness: 0.8 }),
    M({ map: texBois([178, 132, 84], [2, 2]), roughness: 0.7 }),
    M({ color: 0x5a3e24 })
  ]);
  plateau.position.y = -0.14; plateau.receiveShadow = true; etal.add(plateau);
  // jonc décoratif sur la tranche
  const jonc = new THREE.Mesh(new THREE.TorusGeometry(5.06, 0.05, 8, 160), M({ color: 0x8DB255, roughness: 0.5 }));
  jonc.rotation.x = Math.PI / 2; jonc.position.y = -0.02; etal.add(jonc);

  const RAY = 2.75, N = data.length, pas = (Math.PI * 2) / N;
  const paniers = data.map((d, i) => {
    const p = construirePanier(d.forme || (i % 4) + 1);
    const a = i * pas;
    const support = new THREE.Group();
    support.position.set(Math.sin(a) * RAY, 0, Math.cos(a) * RAY);
    support.rotation.y = a;
    support.add(p);
    support.userData.indice = i;
    p.traverse((o) => { o.userData.indice = i; });
    etal.add(support);
    return { support, p };
  });

  // ombre douce au sol sous l'étal
  const sol = new THREE.Mesh(new THREE.CircleGeometry(7, 64), new THREE.ShadowMaterial({ opacity: 0.28 }));
  sol.rotation.x = -Math.PI / 2; sol.position.y = -0.3; sol.receiveShadow = true; scene.add(sol);

  let viseRot = 0, rot = 0, indice = 0;
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function viser(i) { indice = i; const brut = -i * pas; let d = brut - viseRot; d = ((d + Math.PI) % (Math.PI * 2) + Math.PI * 2) % (Math.PI * 2) - Math.PI; viseRot += d; }

  // taille
  function taille() {
    const w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    const etroit = camera.aspect < 1;
    camera.fov = etroit ? 36 : 28;
    const dist = etroit ? 11.5 : 9.4;
    camera.position.set(0, etroit ? 3.8 : 3.1, 1.6 + dist);
    camera.lookAt(cible);
    camera.updateProjectionMatrix();
  }
  new ResizeObserver(taille).observe(canvas);
  taille();

  // interactions : glisser pour tourner, cliquer pour choisir
  const ray = new THREE.Raycaster(), souris = new THREE.Vector2();
  let appui = null;
  canvas.addEventListener('pointerdown', (e) => { appui = { x: e.clientX, y: e.clientY, rot: viseRot, bouge: false }; canvas.setPointerCapture(e.pointerId); });
  canvas.addEventListener('pointermove', (e) => {
    if (!appui) return;
    const dx = e.clientX - appui.x;
    if (Math.abs(dx) > 6) appui.bouge = true;
    if (appui.bouge) viseRot = appui.rot + dx * 0.006;
  });
  const relache = (e) => {
    if (!appui) return;
    if (appui.bouge) {
      const i = ((Math.round(-viseRot / pas) % N) + N) % N;
      viser(i); surChoix(i);
    } else {
      const r = canvas.getBoundingClientRect();
      souris.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(souris, camera);
      const hit = ray.intersectObjects(paniers.map((p) => p.p), true)[0];
      if (hit && hit.object.userData.indice !== undefined) { viser(hit.object.userData.indice); surChoix(hit.object.userData.indice); }
    }
    appui = null;
  };
  canvas.addEventListener('pointerup', relache);
  canvas.addEventListener('pointercancel', () => { appui = null; });

  // boucle (uniquement quand la scène est visible)
  let visible = true, t0 = performance.now();
  new IntersectionObserver((en) => { visible = en[0].isIntersecting; }).observe(canvas);
  const horloge = new THREE.Clock();
  function boucle() {
    requestAnimationFrame(boucle);
    if (!visible || document.hidden) return;
    const dt = Math.min(horloge.getDelta(), 0.05), t = (performance.now() - t0) / 1000;
    rot += (viseRot - rot) * Math.min(1, dt * (appui && appui.bouge ? 14 : 5));
    etal.rotation.y = rot;
    paniers.forEach(({ support, p }, i) => {
      const devant = i === indice;
      const k = devant ? 1.16 : 0.8;
      const s = support.scale.x + (k - support.scale.x) * Math.min(1, dt * 5);
      support.scale.setScalar(s);
      if (!reduit) {
        p.rotation.y += dt * (devant ? 0.22 : 0.05);
        p.position.y = devant ? Math.sin(t * 1.6) * 0.05 + 0.06 : p.position.y * 0.9;
      }
    });
    renderer.render(scene, camera);
  }
  boucle();
  return { viser };
}
